import React from "react";
import { useSelector } from "react-redux";
import AddCamera from "./AddCamera/AddCamera";
import CameraFeed from "./CameraPlay/CameraFeed";
import AddCourse from "./AddCourse";
import AddProfessor from "./AddProfessor";
import AddSchedule from "./AddSchedule";
import AddDevice from "./AddDevice";
import AddEvent from "./AddEvent";
import AddEmploye from "./AddEmploye/AddEmploye";
import AddController from "./AddController/AddController";
import AddRoom from "./AddRoom";
import AlertModal from "./SetAlert";
import ActionModal from "./SetAction";
import CheckInDettails from "./CheckInDettails/CheckInDettails";
import AddUser from "./InviteUser";
import AddRamaStudent from "./AddRamaStudent";
import SaveClipModal from "./Clip/SaveClipModal";
import AddUsecase from "./AddUsecase";

function OpenModal() {
  const { modalType = "", showModal } = useSelector(
    (state) => state?.PopupReducer?.modal || {}
  );

  return (
    <>
      {showModal && (
        <>
          {modalType === "ADDCAMERA" && <AddCamera />}
          {modalType === "CAMERAFEED" && <CameraFeed />}
          {modalType === "ADDCOURSE" && <AddCourse />}
          {modalType === "AddProfessor" && <AddProfessor />}
          {modalType === "ADDSchedule" && <AddSchedule />}
          {modalType === "ADD_DEVICE" && <AddDevice />}
          {modalType === "ADDEVENT" && <AddEvent />}
          {modalType === "ADDEMPLOYE" && <AddEmploye />}
          {modalType === "ADD_CONTROLLER" && <AddController />}
          {modalType === "setalert" && <AlertModal />}
          {modalType === "ADDROOM" && <AddRoom />}
          {modalType === "setaction" && <ActionModal />}
          {modalType === "CheckInDettails" && <CheckInDettails />}
          {modalType === "InviteUser" && <AddUser />}
          {modalType === "ADDSTUDENT" && <AddRamaStudent />}
          {modalType === "SAVECLIP" && <SaveClipModal />}
          {modalType === "ADDUSECASE" && <AddUsecase />}
        </>
      )}
    </>
  );
}

export default OpenModal;
